import { TransportContextType } from '../../../../../../services/types/CalculatorTransportRoads';
import { serviceReducer } from '../../../../../../shared/hooks/serviceReducer';
import { Action, ApiState } from '../../../../../../types';

const calculatorSectorReducer = (
  state: ApiState<TransportContextType, string>,
  action: Action<TransportContextType, string>
): ApiState<TransportContextType, string> => serviceReducer(state, action);

export default calculatorSectorReducer;
